module.exports = __webpack_public_path__ + "img/forgot-password.cdb8f691.svg";